
<div>
	<mat-toolbar color="primary">
		<mat-toolbar-row class="headerStyle">
			<div class="col-md-4 col-sm-4 col-xs-4 imgStyle"><img src="../assets/images/ue-logo.png" class="logoImage"/></div>
			<span class="menu-spacer"></span>
			<div class="col-md-8 col-sm-8 col-xs-8 menu-list">
				
				<!-- <a mat-button routerLinkActive="mat-accent" [routerLink]="'/'" [routerLinkActiveOptions]="{exact:true}"> {{ 'Common.Documentation' | translate }} </a> -->
				<!-- <a mat-button routerLinkActive="mat-accent" [routerLink]="'/dashboard'">{{ 'Header.Dashboard' | translate }}</a> -->
				<!-- <a mat-button routerLinkActive="mat-accent" [routerLink]="'/connectors'"> {{ 'Header.MyConnectors' | translate }} </a>
				<a mat-button routerLinkActive="mat-accent" [routerLink]="'/application'"> {{ 'Header.MyApplications' | translate }}</a> -->
			</div>
		</mat-toolbar-row>
	</mat-toolbar>
	<div class="buttonBody">
		<div class="row buttonDiv headerCol col-sm-12">
			
			<div class="col-sm-6"></div>
			<div class="col-sm-6">
				<span>
					<button><a routerLink="/overview"><mat-icon class="back">home</mat-icon></a></button>
				</span>
				<span>
					<a class="pointers">{{userName}}</a>
				</span>
				<span>
					<a style="color:white;text-decoration:none;" (click)="logout()" class="logout-session">{{ 'Header.Logout' | translate }}</a>
				</span>
			</div>
		</div>
	</div>
</div>	
